import React from "react"
import * as styles from "./textgrid.module.scss"
import {Grid, GridItem} from './grid'
import Text from './text'

export default function TextGrid(props) {
    const items = props.items.map((item,index) => (
        <GridItem key={index}>
            <h3 className={styles.itemTitle}>{item.headline}</h3>
            <Text className={styles.itemText} content={item.text} />    
        </GridItem>
    ))
    return (
        <section>

            <h2 className={styles.title}>
                {props.headline}
            </h2>
            <Grid cols-xs={1} cols-md={2} >
                {items}
            </Grid>

        </section>
    )
}